import { render, staticRenderFns } from "./Settle.vue?vue&type=template&id=f0cc7720"
import script from "./Settle.vue?vue&type=script&lang=js"
export * from "./Settle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports